import React, { useState, useEffect } from "react";
import axios from "axios";
import "./test.css";
import { Link, useParams } from "react-router-dom";
import Header2 from './header2';
import Footer from './footer';
const ImageSearch = () => {
  
  const [keyword, setKeyword] = useState("");
  const [images, setImages] = useState([]);
  const [error, setError] = useState("");
  const baseURL = process.env.REACT_APP_API_BASE_URL; // Ensure your `.env` file has the correct value

  const {did}  = useParams();


  useEffect(() => {
    const fetchImages = async () => {
       

        try {
            setError("");
            setImages([]);

            const response = await axios.get(`${baseURL}/api/images/nature`, {
                headers: { "Accept": "application/xml" },
                responseType: "text",
            });

            console.log("Raw XML Response:", response.data);

            // Parse XML manually using DOMParser
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(response.data, "text/xml");

            // Extract <image> elements from XML
            const imageNodes = xmlDoc.getElementsByTagName("image");

            if (imageNodes.length === 0) {
                setError("No images found");
                return;
            }

            // Convert XML node list into a JavaScript array
            const parsedImages = Array.from(imageNodes).map((node) => ({
                id: node.getAttribute("id"),
                filename: node.getAttribute("filename"),
                folder: node.getAttribute("folder"),
                contributor: node.getAttribute("contributorid"),
                description: node.getAttribute("description") || "No description available",
                width: node.getAttribute("width"),
                height: node.getAttribute("height"),
                src: `http://images.assetsdelivery.com/thumbnails/${node.getAttribute("contributorid")}/${node.getAttribute("folder")}/${node.getAttribute("filename")}.jpg`,
                alt: node.getAttribute("description") || "Image description",
                downloadUrl: `http://api.123rf.com/rest/?method=123rf.images.download.V2&accesskey=&apikey=&custid=&imageid=${node.getAttribute("id")}&resolution=high&apisign=`,
            }));

            setImages(parsedImages);
        } catch (error) {
            console.error("Error fetching images:", error);
            setError("Failed to fetch images");
        }
    };

    fetchImages();
}, []); // Runs whenever `keyword` changes

const handleKeywordClick = (selectedKeyword) => {
  setKeyword(selectedKeyword);
  fetchImages(selectedKeyword);
};


const fetchImages = async (searchKeyword) => {
  try {
    setError("");
    setImages([]);

    const response = await axios.get(`${baseURL}/api/images/${searchKeyword}`, {
      headers: { "Accept": "application/xml" },
      responseType: "text",
    });

    console.log("Raw XML Response:", response.data);

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(response.data, "text/xml");

    const imageNodes = xmlDoc.getElementsByTagName("image");

    if (imageNodes.length === 0) {
      setError("No images found");
      return;
    }

    const parsedImages = Array.from(imageNodes).map((node) => ({
      id: node.getAttribute("id"),
      filename: node.getAttribute("filename"),
      folder: node.getAttribute("folder"),
      contributor: node.getAttribute("contributorid"),
      description: node.getAttribute("description") || "No description available",
      width: node.getAttribute("width"),
      height: node.getAttribute("height"),
      src: `http://images.assetsdelivery.com/thumbnails/${node.getAttribute("contributorid")}/${node.getAttribute("folder")}/${node.getAttribute("filename")}.jpg`,
      alt: node.getAttribute("description") || "Image description",
      downloadUrl: `http://api.123rf.com/rest/?method=123rf.images.download.V2&accesskey=&apikey=&custid=&imageid=${node.getAttribute("id")}&resolution=high&apisign=`,
    }));

    setImages(parsedImages);
  } catch (error) {
    console.error("Error fetching images:", error);
    setError("Failed to fetch images");
  }
};

  return (
   <>
   <Header2 />
    <div className="container card-container">
      <h2 className="mt-2">Image Search</h2>
      <input
        type="text"
        className="image_search"
        placeholder="Enter keyword"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            fetchImages(keyword);
          }
        }}
      />
      <button className="image_search_btn" onClick={() => fetchImages(keyword)}>Search</button>

      

      {error && <p style={{ color: "red" }}>{error}</p>}

      <div className="keyword">
  <ul
    style={{
      lineHeight: '8px',
      margin: '15px',
      listStyle: 'none',
      gap: '22px',
      justifyContent: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      padding: 0,
    }}
  >
    {["Spring", "Easter", "Flowers", "Baseball", "Sun", "Basketball", "Women", "Cross", "Spring background", "Gardening", , "Camping", "Spring flowers", "Vacation", "Easter eggs", "Sunflower", "Easter bunny", "St patrick's day", "Sunglasses", "Easter background", "Landscaping", "Softball", "Passover", "Flower background", "Basketball court", "Festival", "Flower border", "Golf ball", "Earth day", "Happy easter", "Autism", "Air conditioning", "Tulips"].map((item, index) => (
      <li
        key={index}
        onClick={() => handleKeywordClick(item)}
        style={{ cursor: "pointer", padding: "5px", borderBottom: "1px solid gray" }}
      >
        {item}
      </li>
    ))}
  </ul>
</div>



      <div className="image-grid">
        {images.map((img) => (
          <div key={img.id} className="image-card">
            <Link to={`/image-preview/${did}/${img.id}`}>
    <img src={img.src} alt={img.alt} width="200" height="150" />
</Link>
            {/* <p><strong>{img.filename}</strong></p> */}
            {/* <p>{img.description}</p>
            <p><small>Contributor: {img.contributor}</small></p> */}
            {/* <a
              href={img.downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="download-btn"
            >
              Download
            </a> */}
          </div>
        ))}
      </div>
    </div>
    <Footer />
    </>
  );
};

export default ImageSearch;
